const CNPJ_LENGTH = 14;
const CNPJ_BASE_LENGTH = 12;
const FIRST_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const SECOND_DIGIT_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

type CNPJInputValue = string | number | null | undefined;

export function limparCNPJ(cnpj?: CNPJInputValue): string {
  return String(cnpj ?? '')
    .replace(/[^a-zA-Z0-9]+/g, '')
    .toUpperCase();
}

export function formatarCNPJ(cnpj?: CNPJInputValue): string {
  const valor = limparCNPJ(cnpj).slice(0, CNPJ_LENGTH);

  if (valor.length <= 2) return valor;
  if (valor.length <= 5) return `${valor.slice(0, 2)}.${valor.slice(2)}`;
  if (valor.length <= 8) {
    return `${valor.slice(0, 2)}.${valor.slice(2, 5)}.${valor.slice(5)}`;
  }
  if (valor.length <= 12) {
    return `${valor.slice(0, 2)}.${valor.slice(2, 5)}.${valor.slice(5, 8)}/${valor.slice(8)}`;
  }

  return `${valor.slice(0, 2)}.${valor.slice(2, 5)}.${valor.slice(5, 8)}/${valor.slice(
    8,
    12
  )}-${valor.slice(12)}`;
}

function obterValorParaCalculo(caractere: string): number {
  return caractere.charCodeAt(0) - 48;
}

function calcularDigito(cnpj: string, pesos: number[]): number {
  const soma = pesos.reduce((total, peso, index) => {
    return total + obterValorParaCalculo(cnpj[index]) * peso;
  }, 0);

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function validarCNPJ(cnpj?: string): boolean {
  const cnpjLimpo = limparCNPJ(cnpj);

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpjLimpo)) return false;
  if (/^(\d)\1{13}$/.test(cnpjLimpo)) return false;

  const baseCnpj = cnpjLimpo.substring(0, CNPJ_BASE_LENGTH);
  const primeiroDigito = calcularDigito(baseCnpj, FIRST_DIGIT_WEIGHTS);
  const segundoDigito = calcularDigito(`${baseCnpj}${primeiroDigito}`, SECOND_DIGIT_WEIGHTS);

  return cnpjLimpo.endsWith(`${primeiroDigito}${segundoDigito}`);
}
